(function () {
    pagination(true);
})();

(function () {
    const cta = document.querySelector('.gh-main > .gh-cta');

    if (!cta) {
        document.body.classList.add('has-sticky-cta');
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
            document.body.classList.add('has-sticky-cta');
        }
        else {
            document.body.classList.remove('has-sticky-cta');
        }
    }, {
        threshold: 0.5
    });

    observer.observe(cta);
})();

function pagination(isInfinite, done, isMasonry = false) {
    const feedElements = document.querySelectorAll('.gh-feed');
    if (!feedElements.length) return;

    const feedElement = feedElements[feedElements.length - 1];

    let loading = false;
    // The numbered pagination is the crawlable fallback for readers who never scroll; when it's
    // there it doubles as the scroll trigger, and it's kept in step with the last page loaded
    const paginationElement = document.querySelector('.gh-pagination');
    const target = paginationElement || feedElement.nextElementSibling || feedElement.parentElement.nextElementSibling || document.querySelector('.gh-foot');
    const buttonElement = document.querySelector('.gh-loadmore');

    if (!document.querySelector('link[rel=next]') && buttonElement) {
        buttonElement.remove();
    }

    const loadNextPage = async function () {
        const nextElement = document.querySelector('link[rel=next]');
        if (!nextElement) return;

        try {
            const res = await fetch(nextElement.href);
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const postElements = doc.querySelectorAll('.gh-feed:not(.gh-featured):not(.gh-related) > *');
            const fragment = document.createDocumentFragment();
            const elems = [];

            postElements.forEach(function (post) {
                var clonedItem = document.importNode(post, true);

                if (isMasonry) {
                    clonedItem.style.visibility = 'hidden';
                }

                fragment.appendChild(clonedItem);
                elems.push(clonedItem);
            });

            feedElement.appendChild(fragment);

            if (done) {
                done(elems, loadNextWithCheck);
            }

            const resNextElement = doc.querySelector('link[rel=next]');
            if (resNextElement && resNextElement.href) {
                nextElement.href = resNextElement.href;

                const resPaginationElement = doc.querySelector('.gh-pagination');
                if (paginationElement && resPaginationElement) {
                    paginationElement.innerHTML = resPaginationElement.innerHTML;
                }
            } else {
                nextElement.remove();
                if (buttonElement) {
                    buttonElement.remove();
                }
                // Every post is on the page now, so there's nowhere left to paginate to
                if (paginationElement) {
                    paginationElement.remove();
                }
            }
        } catch (e) {
            nextElement.remove();
            throw e;
        }
    };

    // Load while the trigger is still up to a screen below the fold, so readers (and zoomed-out
    // windows) never reach the end of the feed with nothing under it
    const isNearViewport = function () {
        return target.getBoundingClientRect().top <= window.innerHeight * 2;
    };

    const loadNextWithCheck = async function () {
        if (isNearViewport() && document.querySelector('link[rel=next]')) {
            await loadNextPage();
        }
    }

    const callback = async function (entries) {
        if (loading) return;

        loading = true;

        if (entries[0].isIntersecting) {
            // keep loading next page until target is more than a screen below the fold or we've loaded the last page
            if (!isMasonry) {
                while (isNearViewport() && document.querySelector('link[rel=next]')) {
                    await loadNextPage();
                }
            } else {
                await loadNextPage();
            }
        }

        loading = false;

        if (!document.querySelector('link[rel=next]')) {
            observer.disconnect();
        }
    };

    const observer = new IntersectionObserver(callback, { rootMargin: '0px 0px 100% 0px' });

    if (isInfinite) {
        observer.observe(target);
    } else {
        buttonElement.addEventListener('click', loadNextPage);
    }
}